import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { SEO } from 'components/SEO';
import { useAuth } from 'helpers/authContext';
import { Link } from 'react-router-dom';

export const AboutUs: React.FC = () => {
  const { app_settings } = useAuth();
  const isDarkMode = app_settings?.app_mode !== 'default';
  
  return (
    <Container className="py-5 custom-legal-container">
      <SEO 
        title="About Us - Speak on Steem" 
        description="Learn more about Speem, the decentralized video platform for the Steem community."
      />
      <Row className="justify-content-center">
        <Col md={12} lg={10}>
          <div className="text-center mb-5 animate__animated animate__fadeIn">
            <img 
              src={isDarkMode ? "/assets/img/logo-green.png" : "/assets/img/logo.webp"} 
              alt="Speem Logo" 
              style={{ maxWidth: '180px', marginBottom: '25px' }} 
            />
            <h1 className="display-4 fw-bold">Speak on Steem</h1>
            <p className="lead text-muted">Empowering the decentralized future of video content.</p>
          </div>

          <Row className="mb-5">
            <Col md={6} className="mb-4">
              <Card className="h-100 item-speem border-speem-gradient animate__animated animate__fadeInLeft">
                <CardBody className="p-4">
                  <div className="icon-circle bg-wild-green text-white mb-3">
                    <i className="fas fa-bullseye fa-2x"></i>
                  </div>
                  <h2 className="h3 fw-bold">Mission</h2>
                  <p className="description-text">
                    Our mission is to empower video content creation on Steem and Web3, 
                    providing creators with the tools they need to flourish in a decentralized ecosystem 
                    free from traditional barriers.
                  </p>
                </CardBody>
              </Card>
            </Col>
            <Col md={6} className="mb-4">
              <Card className="h-100 item-speem border-speem-gradient animate__animated animate__fadeInRight">
                <CardBody className="p-4">
                  <div className="icon-circle bg-sky-blue text-white mb-3">
                    <i className="fas fa-eye fa-2x"></i>
                  </div>
                  <h2 className="h3 fw-bold">Vision</h2>
                  <p className="description-text">
                    To become technological leaders in the Web3 industry and audiovisual consumption platforms, 
                    aiming for self-sustainability and building solid trust with our users that enables mutual growth. 
                    We strive to redefine how the world interacts with digital media.
                  </p>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <section className="mb-5 animate__animated animate__fadeInUp">
            <h2 className="text-center mb-4 fw-bold">Why Choose Speem?</h2>
            <Row>
              <Col md={4} className="text-center mb-4 text-md-left">
                <div className="mb-3"><i className="fas fa-link fa-2x color-speem"></i></div>
                <h4 className="fw-bold">Decentralized</h4>
                <p className="text-muted">Total ownership of your data and content through the Steem Blockchain and IPFS technology.</p>
              </Col>
              <Col md={4} className="text-center mb-4 text-md-left">
                <div className="mb-3"><i className="fas fa-coins fa-2x color-speem"></i></div>
                <h4 className="fw-bold">Rewarding</h4>
                <p className="text-muted">Direct rewards for creators and curators based on community engagement and value provided.</p>
              </Col>
              <Col md={4} className="text-center mb-4 text-md-left">
                <div className="mb-3"><i className="fas fa-shield-alt fa-2x color-speem"></i></div>
                <h4 className="fw-bold">Censorship Resistant</h4>
                <p className="text-muted">An open platform where voices are preserved immutably, ensuring freedom of expression across the globe.</p>
              </Col>
            </Row>
          </section>

          <section className="text-center py-5 bg-card-speem border-radius-speem animate__animated animate__zoomIn">
            <h2 className="fw-bold mb-3">Join the Revolution</h2>
            <p className="mb-4 text-muted">Be part of the community that is building the future of video.</p>
            <div className="d-flex justify-content-center gap-3">
              <Link to="/new" className="btn-speem btn mr-2">Explore Videos</Link>
              <Link to="/u/steem-seven" className="btn btn-outline-default border-radius-speem px-4">Read Our Blog</Link>
            </div>
          </section>
        </Col>
      </Row>
    </Container>
  );
};
